import { noop } from 'lodash';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconChecked } from '../../../../icon/IconChecked';
import { IconChevron } from '../../../../icon/IconChevron';
import { FormControl } from '../../../../input/FormControl';
import { Input } from '../../../../input/Input';
import { Box } from '../../../../layout/Box';
import { Menu, MenuItem } from '../../../../navigation/Menu';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import { ContentPromotionDropdownProps } from './types';

export const ContentPromotionDropdown: React.FC<ContentPromotionDropdownProps> = ({
    label,
    value,
    options,
    onChange,
    disabled,
    ...other
}) => {
    const t = useTranslation();

    const currentOption = options?.find((option) => option.value === value);

    return (
        <Wrapper {...other} disabled={disabled}>
            <FormControl label={t(label)} width="100%">
                <>
                    <Menu
                        options={{ placement: 'bottom-start' }}
                        width="100%"
                        trigger={
                            <Box width="100%" position="relative" cursor="pointer">
                                <Input
                                    cursor="pointer"
                                    value={currentOption?.label}
                                    onChange={noop}
                                    variant="outline"
                                />
                                <Box position="absolute" right={2} top={2}>
                                    <IconChevron size={16} color="var(--color-primary)" />
                                </Box>
                            </Box>
                        }
                    >
                        {options?.map(({ value, label }) => (
                            <MenuItem
                                key={value}
                                spacing={1}
                                direction="row"
                                justifyContent="space-between"
                                onClick={() => onChange(value)}
                            >
                                <Typography variant="body" noWrap>
                                    {label}
                                </Typography>
                                <IconChecked
                                    size={20}
                                    color={
                                        value === currentOption?.value
                                            ? 'var(--color-primary)'
                                            : 'transparent'
                                    }
                                />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            </FormControl>
        </Wrapper>
    );
};
